const tabs = {
    cover: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'Service Proposal',
                    serverType: 'Service Type',
                    studyId: 'Sutdy ID',
                    companyName: 'Submitted to',
                    address: 'Address',
                    connector: 'Contact person',
                    telephone: 'Telephone',
                    submitCompany: 'Submitted by',
                    submitCompanyAddress: 'Address',
                    submitCompayTele: 'Telephone',
                    makeDate: 'Date of proposal',
                    baName: 'BA',
                    bdName: 'BD',
                    approver: 'Authorized by',
                    validDate: 'Valid period（30 days）',
                    salesforceId: 'Salesforce ID',
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '服务计划书',
                    serverType: '服务类型',
                    studyId: '方案编号',
                    companyName: '提交对象',
                    address: '地址',
                    connector: '联系人',
                    telephone: '电话',
                    submitCompany: '提交方',
                    submitCompanyAddress: '地址',
                    submitCompayTele: '电话',
                    makeDate: '计划书制定日期',
                    baName: 'BA',
                    bdName: 'BD',
                    approver: '审批人',
                    validDate: '有效期(30天）',
                    salesforceId: 'Salesforce ID',
                };
        }
    },
    background: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'Company Background Information',
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '公司背景信息',
                };
        }
    },
    params: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'Study Information&Request',
                    studyId: 'Sutdy ID',
                    productName: 'Product (Medical Devices/Reagent) name',
                    investigationAreaName: 'TA',
                    diseaseName: 'Indication',
                    investigationMedicineType: 'Study Product Type',
                    investigationByStageName: 'Phase',
                    period: 'Stage',
                    siteNum: 'Site Number',
                    filterPatient: 'Screening Pts.Number',
                    randomPatient: 'Randomized Pts.Number',
                    perPtsVisitNum: 'Per Pts  Visit Number',
                    perPtsOnSiteVisitNum: 'Per Pts On-site Visit Number',
                    perPtsTeleVisitNum: 'Per Pts Telephone Visit Number',
                    dataCollectionMedium: 'Data collection medium',
                    saeNum: 'SAE Number',
                    hgracServiceNeedOrNot: 'HGRAC Service need or not',
                    hgracApplicationTimes: 'HGRAC application times',
                    centerPathologicalNeedOrNot: 'Center pathological need or not',
                    radioraphReadingOrNot: 'Radiograph reading or not',
                    patientImageInfoOrNot: 'Patient Image Information',
                    patientImageInfoNum: 'The Number of Patient Image Information',
                    centralLaboratoryOrNot: 'Central Laboratory or not',
                    intensivePKBloodOrNot: 'Intensive PK blood or not',
                    involvingIntensivePKBloodNum : 'Pts.number involving intensive PK blood',
                    eTMFOrNot: 'eTMF or not',
                    servicePeriod: 'Expected Service Period',
                    preparationPeriod: 'Expected Preparation Period',
                    ssuServiceIncludedOrNot : 'SSU service included or not',
                    enrolmentPeriod: 'Expected Enrolment Period',
                    treatmentPeriod: 'Expected Treatment Period',
                    followupPeriod: 'Expected Follow-up Period',
                    survivalFollowupPeriod: 'Expected Survival Follow-up Period',
                    dbl: 'Expected DBL',
                    siteCloseout: 'Expected Site Close-out',
                    crcMonthlyRate: 'CRC Monthly Rate',
                    pmMonthlyRate: 'PM Monthly Rate',
                    fpiDate: 'Expected FPI Date',
                    comments: 'Comments',
                    periodOptions: [
                        { label: '不分阶段', value: '不分阶段' },
                        { label: 'Ia期', value: 'Ia期' },
                        { label: 'Ib期', value: 'Ib期' },
                        { label: 'Ia+Ib期', value: 'Ia+Ib期' },
                    ],
                    dataCollectionMediumOptions: [
                        {label: 'Paper CRF', value: 'Paper CRF'},
                        {label: 'Electronic CRF', value: 'Electronic CRF'},
                        {label: 'NA/TBD', value: 'NA/TBD'},
                    ],
                    defaultOptions: [
                        {label: 'yes', value: '1'},
                        {label: 'no', value: '0'},
                    ],
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '项目信息表',
                    studyId: '方案编号',
                    productName: '试验药物（或器械/试剂）名称',
                    investigationAreaName: '研究项目/治疗领域',
                    diseaseName: '适应症',
                    investigationMedicineType: '研究产品类型',
                    investigationByStageName: '临床分期',
                    period: '阶段',
                    siteNum: '中心数',
                    filterPatient: '筛选病例',
                    randomPatient: '随机病例',
                    perPtsVisitNum: '每例病人访视次数',
                    perPtsOnSiteVisitNum: '每例病人来院访视次数',
                    perPtsTeleVisitNum: '每例病人电话访视次数',
                    dataCollectionMedium: '数据收集介质',
                    saeNum: 'SAE数量',
                    hgracServiceNeedOrNot: '是否需要遗传办服务',
                    hgracApplicationTimes: '遗传办申请批次',
                    centerPathologicalNeedOrNot: '是否需要中心病理',
                    radioraphReadingOrNot: '是否需要中心阅片',
                    patientImageInfoOrNot: '是否有病人影像信息资料',
                    patientImageInfoNum: '病人影像信息资料数量',
                    centralLaboratoryOrNot: '是否有中心实验室',
                    intensivePKBloodOrNot: '是否有密集PK采血',
                    involvingIntensivePKBloodNum : '涉及密采PK例数',
                    eTMFOrNot: '是否使用eTMF',
                    servicePeriod: '研究周期',
                    preparationPeriod: '准备期',
                    ssuServiceIncludedOrNot : '是否包含SSU服务',
                    enrolmentPeriod: '入组期',
                    treatmentPeriod: '治疗期',
                    followupPeriod: '随访期',
                    survivalFollowupPeriod: '生存随访期',
                    dbl: 'DBL',
                    siteCloseout: '关中心',
                    crcMonthlyRate: 'CRC单价',
                    pmMonthlyRate: 'PM单价',
                    fpiDate: 'CRC服务预计FPI时间',
                    comments: '备注',
                    periodOptions: [
                        { label: '不分阶段', value: '不分阶段' },
                        { label: 'Ia期', value: 'Ia期' },
                        { label: 'Ib期', value: 'Ib期' },
                        { label: 'Ia+Ib期', value: 'Ia+Ib期' },
                    ],
                    dataCollectionMediumOptions: [
                        {label: '纸面CRF', value: '纸面CRF'},
                        {label: '电子CRF', value: '电子CRF'},
                        {label: 'NA/TBD', value: 'NA/TBD'},
                    ],
                    defaultOptions: [
                        {label: '是', value: '1'},
                        {label: '否', value: '0'},
                    ],
                };
        }
    },
    detail: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'MedKey Quotation of CRC Service Fee',
                    crcService: 'CRC Service',
                    otherCrcService: 'Other CRC Service',
                    proManagement: 'Project Management',
                    thirdParty: 'Third party pass-through fee',
                    heredity: 'HGRAC Service',
                    preFilter: 'Patient Pre-screening Service',
                    unblindCrc: 'Unblinded CRC Service',
                    total: 'Total',
                    comments: 'Comments',
                    role: 'Role',
                    price: 'Unit Price',
                    cfm: 'CNY/FTE/month',
                    cms: 'CNY/Month/Site',
                    cs: 'CNY/Site',
                    cmp: 'CNY/Month/Person',
                    tc: 'Total/CNY',
                    fte: 'FTE',
                    siteNo: 'Site No.',
                    personNo: 'Number',
                    period: 'Period/Month',
                    cost: 'Fee/CNY',
                    otherRemarks: 'Comments',
                    index: 'No.',
                    commentContent: 'Comments',
                    optionalPart: 'Optional part ',
                    part: 'Part ',
                    digits: ['I', 'II', 'III', 'IV'],
                    inputPlaceholder: 'Please Input ',
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '津石服务费报价',
                    crcService: 'CRC服务',
                    otherCrcService: '其他CRC服务',
                    proManagement: '项目管理',
                    thirdParty: '第三方代垫费',
                    heredity: '遗传办服务',
                    preFilter: '患者预筛服务',
                    unblindCrc: '非盲CRC服务',
                    total: '总计',
                    comments: '备注',
                    role: '人员',
                    price: '单价',
                    cfm: '元/FTE/月',
                    cms: '元/月/中心',
                    cs: '元/中心',
                    cmp: '元/月/人',
                    tc: '总计/元',
                    fte: 'FTE',
                    siteNo: '中心数',
                    personNo: '人数',
                    period: '周期/月',
                    cost: '费用/元',
                    otherRemarks: '其他（备注）',
                    index: '序号',
                    commentContent: '备注内容',
                    optionalPart: '可选部分',
                    part: '第n部分',
                    digits: ['一', '二', '三', '四'],
                    inputPlaceholder: '请选择',
                };
        }
    },
    serverContent: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'MedKey CRC Service Content',
                    num: 'NO.',
                    responsible: 'Task',
                    hasResponsible: 'Y/N',
                    defaultOptions: [
                        {label: 'YES', value: '1'},
                        {label: 'NO', value: '0'},
                    ],
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '津石CRC服务内容',
                    num: '编号',
                    responsible: '职责',
                    hasResponsible: '是否包含此职责',
                    defaultOptions: [
                        {label: '是', value: '1'},
                        {label: '否', value: '0'},
                    ],
                };
        }
    },
    total: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'Quotation-SUM',
                    num: 'NO.',
                    projectName: 'Project',
                    amount: 'Amount/RMB',
                    expenseProportion: 'Proportion of fee',
                    resolve: 'Service Fee Breakdown',
                    discount: 'Need discount',
                    totalAmountPer: '% of total amount',
                    discountTotalAmountPer: '% of total amount after discount',
                    inputPlaceholder: 'Please Input ',

                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '报价-合计',
                    num: '编号',
                    projectName: '项目',
                    amount: '金额/元',
                    expenseProportion: '费用占比',
                    resolve: '服务费分解',
                    discount: '需要优惠',
                    totalAmountPer: '占总计金额百分比',
                    discountTotalAmountPer: '占优惠后总计金额百分比',
                    inputPlaceholder: '请选择',
                };
        }
    },
    payment: function(language) {
        switch(language) {
            case 'en':
                return {
                    en: true,
                    title: 'Payment Schedule',
                    paymentPlan: 'Milestone',
                    paymentNode: 'Proportion',
                    every: 'Settlement every',
                    monthPay: 'month',
                    paymentPercentage: 'Proportion',
                    serviceFee: 'Amount (RMB, including tax)',
                    comments: 'Comments',
                    milestoneNode: 'Milestone',
                    accountInfo: 'Receiving Account Information-RMB',
                    accountName: 'Account name',
                    bankOfDeposit: 'Bank of Deposit',
                    bankAccount: 'Bank Account',
                    inputPlaceholder: 'Please Input ',
                };
            case 'zh':
            default:
                return {
                    zh: true,
                    title: '付款计划表',
                    paymentPlan: '付款计划',
                    paymentNode: '付款节点',
                    every: '每',
                    monthPay: '个月结算一次',
                    paymentPercentage: '付款比例',
                    serviceFee: '付款金额(元，含税)',
                    comments: '备注',
                    milestoneNode: '里程碑节点',
                    accountInfo: '收款账户信息-人民币',
                    accountName: '开户名',
                    bankOfDeposit: '开户行',
                    bankAccount: '账号',
                    inputPlaceholder: '请选择',
                };
        }
    },
}

export function getNamesByLanguage(tab, language) {
    return tabs[tab] && tabs[tab](language);
}


// WEBPACK FOOTER //
// ./src/components/quotation/constants.js